// Mock data for Rock Granites website

export const products = [
  {
    id: 'adhunik-brown',
    name: 'Adhunik Brown',
    slug: 'adhunik-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Classic Adhunik Brown granite with warm earthy tones and natural grain patterns, perfect for flooring and countertops.',
    images: ['1_K1xJ-pUAi91IIwI-F9UUNEsole3vTa0','1EIRCbn9fzxnMexR987VMcIpOp0mJ0eU_','10mofRZB5iorpgkXuUs1H96Irxvtk41b5','1kQPr8cevcF9ZyUECw3QBf2Kn1pPhQ6Dj'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 110,
    featured: false
  },
  {
    id: 'alaska-white',
    name: 'Alaska White',
    slug: 'alaska-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Pristine Alaska White granite with clean white background and subtle grey veining, ideal for luxury interiors.',
    images: ['1n0r_8wOSchkVe_x5uefkFONSiu9iOJCr','1R3mh2fIGGjJM3QTmazzHJ7_zDHvuvTkX','1d8ptHmUztfF-jJapNWpdKH79GXuf2WTS','1a6qH3EZiIfAiLmzm75sVyCandWauV38j','1D-Cg_zr_VZshIFJjyDU084XD7R7VTwIS'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 130,
    featured: true
  },
  {
    id: 'ash-black',
    name: 'Ash Black',
    slug: 'ash-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Deep Ash Black granite with a uniform dark surface, ideal for bold flooring, facades, and high-end commercial spaces.',
    images: ['1G4xn40Do8DvIXlDblV0tD7hqR5mmh1jY','1dZPD_vs1dgiY-vjGawlf7xzvEiLvZWeE','1AdhoPjk3doZoDrEvbEnkIZ7Ux9KygXvp','1FMTe8ZHqQSsJDn_83y861TcX3Q0IuUIf','1pke6MT4kKQ5A_F51cglZRLowtKrqkzUT'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'ash-black-lapatro',
    name: 'Ash Black Lapatro',
    slug: 'ash-black-lapatro',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Ash Black Lapatro finish granite offering a sophisticated semi-matte surface with deep black tones.',
    images: ['10nbDgOoiR7uCJ6ll4_wc8_b4FRfKjXga','1jVWUJ_ChUWLoqOp5FaB9JnDZloknKtqw','1V49ubQn2jW7cOGqHjV73xlCtefr9L9is','1AVLiBhB0-wDvOO7iXPs7DvlLXj7vdpBS'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 125,
    featured: false
  },
  {
    id: 'ashoka-brown',
    name: 'Ashoka Brown',
    slug: 'ashoka-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Rich Ashoka Brown granite with warm brown tones and striking natural patterns for premium applications.',
    images: ['1pvMqceyStUFFC_33rjl9_YCrQhVJCHNe','1pItgsUlhvEv9xmJiY9MM93R9znd5-9-N','16B3yvsTx0vkD9X7InVfFRB4QiRQ8ldow'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'astoria-pink',
    name: 'Astoria Pink',
    slug: 'astoria-pink',
    origin: 'India',
    colorCategory: 'Pink',
    description: 'Elegant Astoria Pink granite with delicate pink hues and fine grain, a favourite for luxury residential and hospitality projects.',
    images: ['16jnIR-Mgfl860pyZtnTnhhtYTdFLYdjB','1QITxRDP2nbbCgC_JOlznKIYHZ_yXjxwt','1dQROm-G9OQooiTTGzph8IjPviSSsXchG','123BwYTe7WNPMsiP20mYTJTBSIdpwKJFm','1lklwdsPJCc2AYH1NfKDil3oHWkUhPfN9'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 135,
    featured: false
  },
  {
    id: 'bash-paradiso',
    name: 'Bash Paradiso',
    slug: 'bash-paradiso',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Stunning Paradiso granite with rich brown, burgundy and golden tones — a timeless classic for luxury flooring, countertops, and feature walls.',
    images: ['1QGnk5Vj_40VTUd_p8CPCrKbMaUNl09VJ','156USSQFDmwf81rBTqW6Whs1vXZKlDecO','1zfDHpJVA1XPqrknqQ9Kk-BgGfgwFtE8k','19LxRDswtHUdf78imF0s_AIKXTBMJeBjK','1TLjYQLzhedtRHXXMmDDbeEVUL7DRCEq8'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 160,
    featured: true
  },
  {
    id: 'black-golden-galaxy',
    name: 'Black Golden Galaxy',
    slug: 'black-golden-galaxy',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Premium Black Golden Galaxy granite with glittering golden and bronze speckles on a deep black canvas.',
    images: ['19ez8TOTuVdmw2Y9qqSEMpn7cdCY3P8vU','1Fs8UTh55nuID_w0BmJ19P1k7-7g7-OzG','1pE0PIy5136jP1z5c5t_8yFVAhw48kfDO','1cJI8CPWgZfbiXtQrNVSXxLUpnit-2gHj','1Dl4lK7BnCSpAjHCAM6ZTjkkrAcF2v12F'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 175,
    featured: true
  },
  {
    id: 'blue-pearl',
    name: 'Blue Pearl',
    slug: 'blue-pearl',
    origin: 'India',
    colorCategory: 'Blue',
    description: 'Distinctive Blue Pearl granite with iridescent blue-grey tones and pearl-like crystals, perfect for statement interiors.',
    images: ['1mNjgTSVZ8gRrgzDllHvgIFAqXgNifX2i','1YdA84HYS1tQE9y0vQAjxdpFOl2NO53MW','12rUvg4bj9c0U_fY75RplYA-Tt6Y1s6W1','1FrxQssG8hGDs751jcbE-sABTScFwEYp1','1cHAawu0boyVsl9fmywfQxRS_Qoo16EmP'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 220,
    featured: true
  },
  {
    id: 'brazil-brown',
    name: 'Brazil Brown',
    slug: 'brazil-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Vibrant Brazil Brown granite with warm brown tones and dynamic natural patterns for a striking finish.',
    images: ['1nDYJ-onkf079T93ao4yPzjB-jtxyLDea','123wNKJme1pjaN27YvoxLAhHsWA6qiMBV','1hQrnNmHI6RjbT0WdQpJh65PelW-Zu5EP','14vm_eOn3GttL0_gGWx0MxlB2L0fP1qVN','1Xu83RDI459puSyu7kLF2WINOVGOqqLYa'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'cat-eyes-brown',
    name: 'Cat Eyes Brown',
    slug: 'cat-eyes-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Unique Cat Eyes Brown granite with distinctive eye-like patterns and rich brown tones.',
    images: ['16Ut5N7Uqx_d9sBgBZeFTj_Jx92mtdeKW','1SyQH1SxIxIvgK83HZb5zTIG0Z50WWhCi','1bJDNraSDR-M2Tx0ko1yy0jWbBQEue_dn','1Alt8c_Z_u7h3HBOpDaT_E99waQCKuyHh','1Ucom89tcRVLY5VvK8TgTW39MLp__5bqi'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'chima-pink',
    name: 'Chima Pink',
    slug: 'chima-pink',
    origin: 'India',
    colorCategory: 'Pink',
    description: 'Beautiful Chima Pink granite with soft pink tones and fine crystalline texture, popular for high-end residential use.',
    images: ['11w6LgFhNZkD52B09E4Jw_UVGkGHD7K7L','1p3R1wjLjkyBtZy9KxXPUkB1jN8D1HDtS','1I_dgI8xSMntozykkaBrc6YnDydNEq67W'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'chima-pink-lapatro',
    name: 'Chima Pink Lapatro',
    slug: 'chima-pink-lapatro',
    origin: 'India',
    colorCategory: 'Pink',
    description: 'Chima Pink in Lapatro finish offering a refined semi-matte surface with soft pink elegance.',
    images: ['1ZKqNjmG-57Yt9HjipkZk-pIY6bAFUx2N','1zz83KdmZ4cF59B6EVtqwnw0V3_BN59sO','1jqLt15eWyzLQDG-U23_To5-Uz_wG7bT7','1oqMhS6fXwKDbu7LqxKLLehZz7-CGMmRF','1DFXG2PWF5NPVNCaMFoTxNmz8CI9hKzvC'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 135,
    featured: false
  },
  {
    id: 'classic-paradiso',
    name: 'Classic Paradiso',
    slug: 'classic-paradiso',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'The iconic Classic Paradiso granite with its hallmark blue, brown and burgundy tones — a perennial favourite worldwide.',
    images: ['1SYSRkUttuwnsWMmTgitY6ams9z54oVzd','15sRn5GcuQpnqG-a2rlrSXHXmZZav-H4Y','17Dd6yte_4GI7_6hi16Zkq78TEGBwffZa','1W6bch0XK-gCX5doXOvDdSfpV0ZhCqodD','1dMihbJs8mNuT1A5wawYFFMhmkBCykITT'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 155,
    featured: false
  },
  {
    id: 'coffee-brown',
    name: 'Coffee Brown',
    slug: 'coffee-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Rich Coffee Brown granite with deep mocha tones and flowing patterns, an elegant choice for countertops and flooring.',
    images: ['1j3Eg60_Cx8NInutNkCbbSt0v_e8Mmk_Q','1Pe1O2JnVqYEsA0cntg_IzY8lmyhQqGmp','1HpLgum3Sl2WOYOqQ1dna9pzoAub74u7f','1pE0BtqEfPl63ECUuZ6Fg_QFAr_lWc42N','1HxLt6orYi5T9JIZDLaQHgIRlnmvMFOMa'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'crystal-blue',
    name: 'Crystal Blue',
    slug: 'crystal-blue',
    origin: 'India',
    colorCategory: 'Blue',
    description: 'Striking Crystal Blue granite with vivid blue tones and crystalline sparkle, ideal for feature walls and statement pieces.',
    images: ['17XS6ZCwfrqSXu55zQj_Vj_yj6un2uhkJ','1FQVzc4xS7qg2MbieOzFh5s3ifbjCQkq8','13lntulFYeh1U6sZ1MCGYU8dgu1keUrqW','1MCXOYu__KDdFaqdsNC0aTV6lNa5pZ8Q'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring'],
    pricePerSqFt: 200,
    featured: false
  },
  {
    id: 'crystal-yellow',
    name: 'Crystal Yellow',
    slug: 'crystal-yellow',
    origin: 'India',
    colorCategory: 'Yellow',
    description: 'Vibrant Crystal Yellow granite with warm golden-yellow tones and a sparkling crystalline surface.',
    images: ['1Jl0mMvIzMogvZHcBwv3wQgnq8KqK-ZUy','1PicVei4C3omOoiyfamu091TvkcvNTOdz','1Feo4uMtdYu6lF4UQILCSclM4PrO8NEAR','1TTgGFPq2eW3joMPiUahMP-KlJ1s0FzLq','1uxehanBeum1xZJarXl1xV95j_-TIGfq1'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring'],
    pricePerSqFt: 190,
    featured: false
  },
  {
    id: 'dark-black',
    name: 'Dark Black',
    slug: 'dark-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Intensely dark and uniform Dark Black granite, the go-to choice for bold contemporary architecture and interiors.',
    images: ['1oDJIkrcTKcgXi-gXw3N87i4mZKYz8axq','1i4XPli6_X2dsy5Ca7adCkLJ3nWku543S','1G29WHfe3rUk1fV08Xq3_jZKF4TDsLv2J','13QpqHvk_6mx54ddWt_2ml0hsEQqmVek3','116XktlRDEntT0YUMLwbblOKGrDUWe-Od'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'desert-green',
    name: 'Desert Green',
    slug: 'desert-green',
    origin: 'India',
    colorCategory: 'Green',
    description: 'Exotic Desert Green granite with muted sage and olive tones, a unique choice for nature-inspired luxury interiors.',
    images: ['1lWPy4CxFFVStF3uib6KybeybgAS2pyfj','1gFFksRyC-BT_2AbMQ67g5yjGQrBybLwc','1HmGqS3UKEp-MG-9gvpSLXsEGmjgyuDx6','1KuAJWwdpNO8EAPgOtBVzx02cua6LMBD3','14gkuUNkyeupbKejPSd4eBrYIKjFE7iu9'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Countertops', 'Facades'],
    pricePerSqFt: 145,
    featured: false
  },
  {
    id: 'desert-green-lapatro',
    name: 'Desert Green Lapatro',
    slug: 'desert-green-lapatro',
    origin: 'India',
    colorCategory: 'Green',
    description: 'Desert Green in Lapatro finish with a sophisticated semi-matte surface, enhancing its natural green beauty.',
    images: ['1qp2L8FqQo5W5og9Tjd-1oPeyy4y1JhIf','1YI-DIrrOkgHZZ-vYFkR73Y84HFFb3c9Q'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 150,
    featured: false
  },
  {
    id: 'fish-black',
    name: 'Fish Black',
    slug: 'fish-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Fish Black granite with a distinctive flowing black pattern, highly sought after for dramatic flooring and cladding.',
    images: ['1QU7cr0GrXT4o4lnVgohmLh_d336dXYDq','16_GlYAYfI4VEd3OEBo-MX8fZasC-v1ug','16De17mdoCrk5O3xprhmJRMJwK4BYYmPt','1uAU9B4rgMrHbjJS7jnhsRxZlCQb9NyLB','1wyiHPgKWSzWXC-WAhHWKxNBBsYVNpoR6'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 125,
    featured: false
  },
  {
    id: 'fish-brown',
    name: 'Fish Brown',
    slug: 'fish-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Fish Brown granite with flowing brown patterns that give each slab a unique organic character.',
    images: ['1uL1aqTW7WeKfDfLiW4KMEkWeXOhThT2S','1IWxC52VNhg6dRA9zNriGst-RgAWZtq0U','17TI-KXT-mwXXP-7OqInkhRLJwmSjpUpq'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 118,
    featured: false
  },
  {
    id: 'french-white',
    name: 'French White',
    slug: 'french-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Refined French White granite with a bright white base and subtle grey veins for a timeless European aesthetic.',
    images: ['1xzIxKiCViffLTwb70_-IWjTQbd7qBJcL','1TdkyHkYhjTfTdYl7Tzg22lhQkUn_562m','1qRtVMf7WAQfEZfcFeC37OuypVaJwuG9z','1B60B8ZeQTmY5SFC46KZzB5kl39uRdRir'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 140,
    featured: false
  },
  {
    id: 'gem-red',
    name: 'Gem Red',
    slug: 'gem-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Vivid Gem Red granite with deep crimson tones and fine mineral speckles, making a bold statement in any space.',
    images: ['149BKfgm3sDHD7OThoh7SOzbS6GLjURZT','1Uc-XcuYGSOuDqcTE9qT-PEsHkA23GPNK','1xg8utdY7ap0VLT_CfCdwv3t3dP2pbcwZ'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 140,
    featured: false
  },
  {
    id: 'himalayan-brown',
    name: 'Himalayan Brown',
    slug: 'himalayan-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Majestic Himalayan Brown granite with earthy brown tones inspired by the grandeur of the Himalayas.',
    images: ['1If01jzmCAI4N_0lkZ_IZl7WOSTz8ddZf','1hKaRts5jaEKbxCSlLznHyalXcXQAWRaH'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 125,
    featured: false
  },
  {
    id: 'honey-blue',
    name: 'Honey Blue',
    slug: 'honey-blue',
    origin: 'India',
    colorCategory: 'Blue',
    description: 'Rare Honey Blue granite combining warm golden tones with cool blue accents for a truly distinctive look.',
    images: ['1Kmzqi5QQ6JwvwtO28ecarsZ_B2zg4Vy4','1FKcz2D_N_zPGE4osMVjiyRkoxcX1SCNv','13k1jAAnAbfdm9TAzKPzCDW2irinLQGcB','1kmGTDHr6jKKVrtyBiE5FPl0GV1kF1NBm','1RQ7A5B438b4iIJ6kdWWizpMzqcd3zvJk'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring'],
    pricePerSqFt: 210,
    featured: false
  },
  {
    id: 'imphala-black',
    name: 'Imphala Black',
    slug: 'imphala-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Premium Imphala Black granite with a uniform deep black surface and fine grain, ideal for sophisticated interiors.',
    images: ['1ikWDJ7xows-ZoertlstYPpKgWYJV6hZB','1-E42eA8xAspVmaJnyAg9ApJKwCfaDje6','1TPm1hAWYvjfLmTWxDxXHBKYB4ROr_Fng','1E4_bXw66rxlbPlS7ZfyjsA0nBquno-ZT'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'indian-waves',
    name: 'Indian Waves',
    slug: 'indian-waves',
    origin: 'India',
    colorCategory: 'Grey',
    description: 'Distinctive Indian Waves granite with flowing grey and white patterns. Ideal for contemporary interiors, steps, countertops, and large-format flooring.',
    images: ['1aw7U1XYaAiQ_lyBJXAwKf19rm4nei_0A','1nqxy7gC5G8GhTsLy-1oPjO3AwAwTvH7y','1qepDeDsnicRupDa03yxXUI1WlYZpx3FW','1m89JNnjQy_3fY9sf8-kF54Pl0XOUEWbu','1PQy4pAA6Br08YeVHA3sdw_lJGk4iAL0u','1f7qzm338ZKm_arlDWrNti63Junk6phjm'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Steps', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 140,
    featured: true
  },
  {
    id: 'kharda-red',
    name: 'Kharda Red',
    slug: 'kharda-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Bold Kharda Red granite with intense red tones and natural veining, a powerful choice for facades and flooring.',
    images: ['1XRq9hxAj6LcL9M4rZ-N-6d-H377sPB7D','102yDIyKIGYkp-CUJZtmEedvIYCXmexLN','1_vVKaXKCG8KK3t5Hl5jYz_6G4RKPbKPl','1USqGJYbMEAn-KwGzZxVeTw7MXMTMuNsf','1SW2GxC5tBzCUD_FsgQy7_hQe-2-bAqIv'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'lakha-red',
    name: 'Lakha Red',
    slug: 'lakha-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Classic Lakha Red granite with warm red tones and natural mineral inclusions, widely used in export markets.',
    images: ['11Y_x6DCMNB3Ok3ypBzuURcqdQMjyXcVS','1r2F3uqiGJVmsiwVut91CPy9s_cAenUXr','1dxsPOFHg42G-nlv0ryc1MLzXbEdPY5RD','1-yiorp2SZDLVoRztJ9ZvyFif_7NXLPh4','1BpFN8Fkwqu2fu9-cmGJW9GGZUM-6sWOd'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 125,
    featured: false
  },
  {
    id: 'laxmi-brown',
    name: 'Laxmi Brown',
    slug: 'laxmi-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Warm Laxmi Brown granite with rich earthy tones and consistent grain, reliable for large commercial projects.',
    images: ['15ZuwmQxJrOO1tpk5q0GcTPNJqI4d1ZYG','1HwndelPwvtkqNKJB6jxs3VObLrjY94SM','1gIc0hWAQd9ThFe5Ui2ZIHOVATPVGSwIq'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 110,
    featured: false
  },
  {
    id: 'madka-black',
    name: 'Madka Black',
    slug: 'madka-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Madka Black granite with a deep black surface and fine mineral speckles, an economical choice for large-scale projects.',
    images: ['1KTCapteBC5Gpj8TSMgrRQ1Ffvq-A5D_L','1V4fOYcphePm_xf3adLfxHBrE4oJMnjNO','1N99ntWPAl6UdYNDYz99WhR3En2KkzSpx'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 100,
    featured: false
  },
  {
    id: 'majestic-black',
    name: 'Majestic Black',
    slug: 'majestic-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Premium Majestic Black granite with an exceptionally deep black surface, favoured for luxury commercial and residential projects.',
    images: ['1IJZNvnIBEezJw0paN_pP8A_-mLdoRfxy','1AJPJTj-w0eorsCe305PjVJFMx_0om94l','1NpAbQm4AZrKaPxHw9bbj_26tLDl9169x','19hZawtKq1DqDJAkWy_vcLl8ujS4WlY0Z','1zAruoAM-eQwJJwok6WhGM5p_cXEMb-Lf'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 140,
    featured: false
  },
  {
    id: 'majestic-black-lapatro',
    name: 'Majestic Black Lapatro',
    slug: 'majestic-black-lapatro',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Majestic Black in Lapatro finish, offering a luxurious semi-matte depth that elevates any interior.',
    images: ['13JeHJ8yMPDZheMUdliyiJzHLCNSeMSTD','1QK2yeN8O63eLlFQy8dhZegsh5-OtutE_','1TC22VtV3SXUr7D6MBUjJjAd0oEV-8pw1','1uyWn05Khd13vynCvcXQQVdWgnyMMCxgv','1HZY_khYJyCtl0mPkBRHqwapNAlh8mtfd'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 145,
    featured: false
  },
  {
    id: 'marina-blue',
    name: 'Marina Blue',
    slug: 'marina-blue',
    origin: 'India',
    colorCategory: 'Blue',
    description: 'Elegant Marina Blue granite with deep oceanic blue tones and natural white veining for a dramatic effect.',
    images: ['1R5kThgdDnfSd-as0aLkDz02kyDzQed6y','1NcgSaj-VVRUCsjwCFJTXsPKRX7FqFGG8','1tmpY4l4BPoAVtoV9JnLsEfTQjUX0R6e-','1sBxcXo7p8aTUQjFRr4WKUjNU2QOyDyTI','116GUFPzDS3agyXIA5ZJWioJUMX73L5qf'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring', 'Facades'],
    pricePerSqFt: 215,
    featured: false
  },
  {
    id: 'markino-black',
    name: 'Markino Black',
    slug: 'markino-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Markino Black granite with a consistent black surface and subtle texture, widely used in export-grade projects.',
    images: ['1Qemtput1DfpQ7ETxgL7ChRWvSP1_TwkH','1C6xoNjJsr2WI82z18CEQ4j0xUnGqFMNB','1hs_zJQsnwnWX1ocIIJnAv4qVz7BHbIL1','1rIahHGm36s7FjGppNXSpevHasY-HMC05','1D4savECw9hcZJQJEekXwTSkkQDVP9ona'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'markino-black-lapatro',
    name: 'Markino Black Lapatro',
    slug: 'markino-black-lapatro',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Markino Black in Lapatro finish, combining a sleek semi-matte surface with consistent black depth.',
    images: ['18eol7kIBlZlxdOyYOYilHTYDDN2Iewx_','1dvqqoTk_3Mc4LbYraJFm6MV2rm6wRYY_'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'mudgal-grey',
    name: 'Mudgal Grey',
    slug: 'mudgal-grey',
    origin: 'India',
    colorCategory: 'Grey',
    description: 'Versatile Mudgal Grey granite with consistent grey tones, perfect for modern commercial and residential flooring.',
    images: ['1Y9iAN9esOidnathzSz2Khqjq2gaB10w7','1RjYNu5miF3WdN71Upqg8Bo_jti5a1IxI','1gItdjZBTBxKgiZJ9izGWBkWd3tBC7qUM','1XT8GDf7hlWh2A6jSJ_WM1ULC_Mu7n8Tb','1mlfdLgNgblTdgiSBChgtwJatfxPNiFAi'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Paving', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 105,
    featured: false
  },
  {
    id: 'nano-white',
    name: 'Nano White',
    slug: 'nano-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Ultra-pure Nano White granite with a bright white surface, bringing a clean minimalist aesthetic to any project.',
    images: ['145kCWxwt4AOK1zzC0p3lAalCzcuomji7','1DSE01G0S19D0rB9aIcE-HsZy3ZZEVijY','1y9L-CXJQdXc65FKWMYu6f8Mfnip4PsR3','10PVKRU83Ry2FBSWSOiz_uZVNorBd_o1c','17W6aJiI_SQehpAzl53S0GC6Mz04sZpNu'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 145,
    featured: false
  },
  {
    id: 'nk-red',
    name: 'NK Red',
    slug: 'nk-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Bold and vibrant NK Red granite with deep red tones and natural variations. Perfect for statement flooring, facades, and high-end commercial projects.',
    images: ['1P3M1TKuvXwfCch7jl8gBM4sf_rk4JUjb','1ffMTYAdUKwRqEoBG-dFQhXv_26gm3dEe'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding', 'Countertops'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'nurella-grey',
    name: 'Nurella Grey',
    slug: 'nurella-grey',
    origin: 'India',
    colorCategory: 'Grey',
    description: 'Elegant Nurella Grey granite with smooth grey tones and fine grain, a popular choice for contemporary architecture.',
    images: ['162QpHtozCLt22BPY3d3oCnVkFgTKFq-t','1OUKYbd5s989YKhIBJC62FRrOTRse-WyC','1IlbQYOs483NChg4U7yEUu628NsIJxH1D','1tA5rP3TJV20DcvqsEZQKrOx0C0TgKFef','1M06bwQ8BKV9nz9IsgRtZSsgH3wwDhj4x'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Paving', 'Wall Cladding'],
    pricePerSqFt: 110,
    featured: false
  },
  {
    id: 'paradise-white',
    name: 'Paradise White',
    slug: 'paradise-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Heavenly Paradise White granite with a luminous white surface and delicate natural veining for a serene finish.',
    images: ['1TvAA0q_I1vMCQ8sl9u2mqbsHNxKS_plK','1lwlawXmMuRVkX3DkIRAQvuDOKaE57G58','1UYdn-x_hmr2OViUr0scBfPZ3KxjSnB0L','1KUXhUh1BZCG5iuwY3wwecw8WDipHhkWM','1iWuhxAkMJyxJgn8aRxoVHkUQ9ejwzH1N'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 150,
    featured: false
  },
  {
    id: 'pearl-black',
    name: 'Pearl Black',
    slug: 'pearl-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Exquisite Pearl Black granite with lustrous black tones and pearl-like mineral inclusions for a premium look.',
    images: ['19c4T_wODozdJeipIiGtkEu651DVF35Xs','11iMQ8YoSueSIyXydtocxfavvmif0eroi','1rPOmBXuxQhMV9sQXWwT3Ha3-VOLJ7FTx','16pmu1r0H2UNVwQux_-XOSujvsMeQq6y2','1R_2QqIsA8-nEtjlGiKNzfKSDlP6SLwOB'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 155,
    featured: false
  },
  {
    id: 'pista-green',
    name: 'Pista Green',
    slug: 'pista-green',
    origin: 'India',
    colorCategory: 'Green',
    description: 'Refreshing Pista Green granite with a soft green hue and natural variations, perfect for feature walls and accent pieces.',
    images: ['1hT4FU8geCUpozzCMtWH1sArTL8Z58H-M','1IjHmHKeKSFLwu0w_kbtAnaL1hZxosFwn','1ZrBrknO5ez3HIXq_kUm0DfNvNWz7Wf5k'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring'],
    pricePerSqFt: 160,
    featured: false
  },
  {
    id: 'platinum-white',
    name: 'Platinum White',
    slug: 'platinum-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Luxurious Platinum White granite with a pristine white surface and subtle platinum-toned veining for an ultra-premium finish.',
    images: ['1m6AfvElxeAn778iRKVvVWIHla8T3SIDs','1hrS0tf_5LGqutbJYDZ5GKVkoJAtXsoab','1bv2XERXq0v71j_hKO6LaMZkKNcnGPnmz','1-nga5oxIfELkNclEPfO6DbdmKL7g9PDw','1M7qFzY2rtANl4xqbywD-e41Mcz0ZQZcS'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 165,
    featured: true
  },
  {
    id: 'platinum-white-lapatro',
    name: 'Platinum White Lapatro',
    slug: 'platinum-white-lapatro',
    origin: 'India',
    colorCategory: 'White',
    description: 'Platinum White in Lapatro finish — a soft matte brilliance that adds depth and elegance to white granite.',
    images: ['1Dgn5MPzD9GVULEZSjA7iihIEIyem78Go','1v-kxdWjrpaI-M4kVZSSUiIiyeaw_wGj2','15KAFcU-Jiw4qcwk13qPRahOehGMTSENI'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 170,
    featured: false
  },
  {
    id: 'r-black-pearl',
    name: 'R Black Pearl',
    slug: 'r-black-pearl',
    origin: 'India',
    colorCategory: 'Black',
    description: 'R Black Pearl granite with a distinguished black base and shimmering pearl-like inclusions for a premium decorative appeal.',
    images: ['14SBVFv93Y6bC_cLOuxWyZGkRyqbEJSQ3','1lSCPErwqqDUJSpnPCB8W84juofvw7Ks9','195LWDkGzno5_396s3Cx7ASODhOzD0y_a','1sWk4PMIiaE7bijGD_LS7JRuvRXgMorVU'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 160,
    featured: false
  },
  {
    id: 'r-black-pearl-lapatro',
    name: 'R Black Pearl Lapatro',
    slug: 'r-black-pearl-lapatro',
    origin: 'India',
    colorCategory: 'Black',
    description: 'R Black Pearl in Lapatro finish — the iconic pearl-black character with a refined semi-matte texture.',
    images: ['1el1HWzsPiwg90C_lL4AH1NmHchloG9mh'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding'],
    pricePerSqFt: 165,
    featured: false
  },
  {
    id: 'r-tan-brown-lapatro',
    name: 'R Tan Brown Lapatro',
    slug: 'r-tan-brown-lapatro',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'R Tan Brown in Lapatro finish — warm earthy tones with a sophisticated semi-matte surface treatment.',
    images: ['1Ntp0YBL8veRhk9iOl95KnK7A8qqRqES1'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'rainbow-teak',
    name: 'Rainbow Teak',
    slug: 'rainbow-teak',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Exotic Rainbow Teak granite with multi-toned brown, orange and grey patterns reminiscent of teak wood grain.',
    images: ['1TMSiXzF2LOuaGWgh4OPZDSkv7jzU6i5y'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 135,
    featured: false
  },
  {
    id: 'rainforest-brown',
    name: 'Rainforest Brown',
    slug: 'rainforest-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Lush Rainforest Brown granite with organic brown and green tones, evoking the richness of tropical forests.',
    images: ['1V8aio0hME6gNq78ZoSQpiBzy_dspT3oy'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 140,
    featured: false
  },
  {
    id: 'redlawada-black',
    name: 'Redlawada Black',
    slug: 'redlawada-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Redlawada Black granite sourced from Karnataka quarries, known for deep black uniformity and export-grade quality.',
    images: ['1M4fltGnMSbNAzSnY5ELw20K0UUqelb85'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 110,
    featured: false
  },
  {
    id: 'rolight-pink',
    name: 'Rolight Pink',
    slug: 'rolight-pink',
    origin: 'India',
    colorCategory: 'Pink',
    description: 'Charming Rolight Pink granite with warm pink tones and subtle grain patterns, ideal for elegant interiors.',
    images: ['1fOvzFfIYyPek-2kQHdUBZ4na1B1BtC5K','13rX3IDUqwtPvqSuab2Fq_75tyIgrIXBQ','19og_d_X3aWgUm4HaLiJEAhO4Nqxy43zl','1spP7VPMhuZJSMsho-Qu3lHyvMHzKVqXq','1Dy52hoI2vqIL-y5MIABdp_ywxH29_XRb'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 125,
    featured: false
  },
  {
    id: 'rosy-pink',
    name: 'Rosy Pink',
    slug: 'rosy-pink',
    origin: 'India',
    colorCategory: 'Pink',
    description: 'Rosy Pink granite with a warm blush tone and crystalline finish, a romantic and sophisticated choice.',
    images: ['1uUZh0OUJ9j9eIPLdp-POj1_psv18LxVT','1nzyEl1fnw7T16zAZShoQYTILW2YYD9fB','1JS6TgTdO1urn_nZ_WaXGTOfSYJeEHv4t','1cMDG9IbA-0nQcjxSJvndjERqjcprLTCu','1zqKoKIXy2zNCq1MKf0jrSh0Lu2n4NT4H'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 's-white',
    name: 'S White',
    slug: 's-white',
    origin: 'India',
    colorCategory: 'White',
    description: 'Clean and crisp S White granite with a uniform white surface, a reliable choice for commercial interiors.',
    images: ['1pdc9II8CT-GirKwOEAmsOqzxMglPEA_V'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'sadarhalli-white-antique-flamed',
    name: 'Sadarhalli White Antique-Flamed',
    slug: 'sadarhalli-white-antique-flamed',
    origin: 'India',
    colorCategory: 'White',
    description: 'Sadarhalli White in antique-flamed finish offers a textured, aged surface ideal for outdoor paving, steps and rustic interiors.',
    images: ['13uedW6RTunXCoggsFikCgHavh0VDvvVq','1AUXipjU4_eKMwz0l3pYymN-X0jsk6IdW','1z2EYc_bYaFnaTzH4Ogjat-FlwkY33FS_','1m5KNpHOzGqZR93s8j2IV-KqxwaWIbVja','1ysGW9YfErZ3qmN8Q_PulDZnQxRfWiQrr'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Flamed', 'Antique', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Outdoor Paving', 'Steps', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 135,
    featured: false
  },
  {
    id: 'saffron-gold',
    name: 'Saffron Gold',
    slug: 'saffron-gold',
    origin: 'India',
    colorCategory: 'Yellow',
    description: 'Radiant Saffron Gold granite with warm golden tones and natural veining, adding warmth and luxury to any space.',
    images: ['1BxhHRVgtF9QHwrBu1wkoZokvyzaIwMCP','1s1f4jFGAlHUsTqaK0kzyc4hwYlNO2EFi','1E4KjdYv9YxIVsv5_oikmR6ie82lDlIKy'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 180,
    featured: false
  },
  {
    id: 'steel-gray',
    name: 'Steel Gray',
    slug: 'steel-gray',
    origin: 'India',
    colorCategory: 'Grey',
    description: 'Industrial-chic Steel Gray granite with consistent grey tones and fine grain — a top export variety for modern architecture.',
    images: ['1MrNH-IbrkOx0XB2qVIJqahPKEnDjNowy','1iEIMJXDB3X7bGt_KMTiD9BSjpuLiSWDJ','1JdAD9ApQayPZqP5qaoA-mYGzOC4tacPv','1tSqcSKmErV0t9XqjmFdG9x394EpQCHoz','1Po9SR7Lt0R_75xquVNiPiXvpgqaxJR17'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Paving', 'Wall Cladding'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'steel-gray-lapatro',
    name: 'Steel Gray Lapatro',
    slug: 'steel-gray-lapatro',
    origin: 'India',
    colorCategory: 'Grey',
    description: 'Steel Gray in Lapatro finish — a sleek semi-matte grey surface perfect for contemporary commercial flooring.',
    images: ['1xARjzgtpIagDN7buLoPe-uPrhgzZHG0P','1uLjvdPRXjFaCwg_xelLqb94ujIKT8kH7','1zeSBs_q2y50EP5a5KO7WaC5SWA4XMol5','1F5bMS37_g1S72Tp8kdEpkQ2WNRyO-_MF','1shsbcU30p9dOO2kg6umZyLO_a-b71tWR'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'tan-blue',
    name: 'Tan Blue',
    slug: 'tan-blue',
    origin: 'India',
    colorCategory: 'Blue',
    description: 'Unique Tan Blue granite blending warm tan and cool blue tones for an unconventional and striking appearance.',
    images: ['1i5Vw7e82IEFRzpYcvbL-GuTFe6Af0aiI','1gsampd89O4p6QffDxaU6x9M5gr3GZ0V2'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Wall Cladding', 'Countertops', 'Flooring'],
    pricePerSqFt: 195,
    featured: false
  },
  {
    id: 'tan-brown',
    name: 'Tan Brown',
    slug: 'tan-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Globally recognised Tan Brown granite with rich brown tones and black and grey patterns — a perennial favourite in export markets.',
    images: ['1NBeyrqOgWf0SvJfDgkxTBfzFkb9gb3Kf','1faxVrBK_T9DuqA45q_rgStR-s-wQ-PrF','1Ot0_TSRkpd9y-BJ1zClLIlZ8emgOC55X','1MD5Xmqvick3DIZDceK7m6264TqSIl4pY','1wdJzC994YZfjB91_McnFVwBFXLQN8dPj'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Countertops', 'Flooring', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 110,
    featured: false
  },
  {
    id: 'tan-red',
    name: 'Tan Red',
    slug: 'tan-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Tan Red granite with warm red-brown tones and natural patterning, suitable for both interior and exterior use.',
    images: ['1OiW9XTJCUAiQdplzPjMGyVeN7jGqWV4H','1FzUQsqt1vNgS48rWaG8jtuZGjs0taQE_'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 115,
    featured: false
  },
  {
    id: 'tan-red-lapatro',
    name: 'Tan Red Lapatro',
    slug: 'tan-red-lapatro',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Tan Red in Lapatro finish — a rich semi-matte surface that brings out the natural warmth of red-brown granite.',
    images: ['18SBI2gaFOSj3jIquxoLJjTKm76odhecq','1VbQl-8kGfV3KUIVK5vCEYl4p26RjLmSy'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Lapatro', 'Polished'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Wall Cladding'],
    pricePerSqFt: 120,
    featured: false
  },
  {
    id: 'teak-stone',
    name: 'Teak Stone',
    slug: 'teak-stone',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Teak Stone granite with warm wood-like brown tones and flowing grain patterns for a natural organic aesthetic.',
    images: ['1fxcAKZtjpyHETYleRxpqUZf6iIXVz4ad','1An1ByrOn2a6KPdZM-pGq8yeEsWWvvPAe'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'telephone-black',
    name: 'Telephone Black',
    slug: 'telephone-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Telephone Black granite with a distinctive dark surface and fine natural texture, widely used in monuments and architecture.',
    images: ['1-Mkdv9uKfxwiVTdALumIKDMtMt0q4r7l','1sKPJmXBa5MkAp5kGGFm9J5YgQ1L4_xL0','1qg5RgULR4Z6O_ownTWy98nv6dF68vuJz','1Y4JvMfOS6W8fjn7z8IeeCJt_vabO-SxL','1RZm_ztv3UYUQL8ZdDlSoxHeW3MEpmXoG'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Monuments', 'Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 105,
    featured: false
  },
  {
    id: 'tiger-black',
    name: 'Tiger Black',
    slug: 'tiger-black',
    origin: 'India',
    colorCategory: 'Black',
    description: 'Tiger Black granite with dramatic black tones and tiger-stripe-like natural patterning — a bold statement material.',
    images: ['12f4VsVYTMj71f7C293YgcbNmVUFWoK_A','10L8icIlTJHAPVhoGIY59jHvTu7G5rPum','1F07YcbUWFxDpJyARU2MFbRUcjAE_fQxv','1ExT3gXIZ-OCo7L86qkvXp0jvlwT-IIvI','1PmtlqKKnjRmyviMb6QH_cqW3G3Wwd96t'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Flamed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Facades', 'Wall Cladding'],
    pricePerSqFt: 130,
    featured: false
  },
  {
    id: 'wine-red',
    name: 'Wine Red',
    slug: 'wine-red',
    origin: 'India',
    colorCategory: 'Red',
    description: 'Deep Wine Red granite with rich burgundy tones and fine mineral inclusions — a luxurious choice for statement interiors.',
    images: ['1Ojie4X-GknOmuNUb2vKmsg3WjhDeMDmZ','13qvwI5VnJUJwRggOG3E8BSYzKtOsSz0K','1UxHB1Z0Np2OxBNB3ELSqJn9gez-JTjQ5'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding', 'Facades'],
    pricePerSqFt: 145,
    featured: false
  },
  {
    id: 'zed-brown',
    name: 'Zed Brown',
    slug: 'zed-brown',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Zed Brown granite with warm brown tones and consistent grain pattern, a reliable choice for large-scale flooring projects.',
    images: ['1Qx3pm3mEy9vTKXrzc1ZLJZN5hV136dYG','1fWfxRZ-BdYc0-sW78Lsp-pzXuzVaO14e'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Polished', 'Honed', 'Leather'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Flooring', 'Countertops', 'Wall Cladding'],
    pricePerSqFt: 108,
    featured: false
  },
  {
    id: 'zed-brown-antique',
    name: 'Zed Brown Antique',
    slug: 'zed-brown-antique',
    origin: 'India',
    colorCategory: 'Brown',
    description: 'Zed Brown Antique with a weathered, textured surface finish — ideal for rustic, heritage and outdoor applications.',
    images: ['1Qx3pm3mEy9vTKXrzc1ZLJZN5hV136dYG'].map(id => `https://lh3.googleusercontent.com/d/${id}`),
    finishes: ['Antique', 'Flamed', 'Honed'],
    slabSizes: ['2800 x 1600mm', '3000 x 1800mm'],
    thickness: ['18mm', '20mm', '30mm'],
    applications: ['Outdoor Paving', 'Steps', 'Flooring', 'Wall Cladding'],
    pricePerSqFt: 112,
    featured: false
  }
];

export const projects = [
  {
    id: 1,
    title: 'Luxury Hotel Lobby',
    category: 'Hospitality',
    image: 'https://customer-assets.emergentagent.com/job_ad7e8f87-1d9a-44c7-94bb-e1bf1711e4b9/artifacts/qjow4xuy_hf_20260124_182851_9a4762c2-e640-4d68-9813-a43a63082d02.png',
    description: 'Premium black granite flooring and feature walls'
  },
  {
    id: 2,
    title: 'Commercial Building Facade',
    category: 'Commercial',
    image: 'https://customer-assets.emergentagent.com/job_ad7e8f87-1d9a-44c7-94bb-e1bf1711e4b9/artifacts/1s33djgv_hf_20260124_183210_010821e2-0015-49bf-9a08-950e6b5e3427.png',
    description: 'Large-scale granite cladding for contemporary architecture'
  },
  {
    id: 3,
    title: 'High-End Residential',
    category: 'Residential',
    image: 'https://customer-assets.emergentagent.com/job_ad7e8f87-1d9a-44c7-94bb-e1bf1711e4b9/artifacts/czggq0wy_hf_20260124_182414_4eeb45b5-502b-4c7a-83ee-1b1917aa5015%20%281%29.png',
    description: 'Luxury home interiors featuring Kashmir White countertops'
  },
  {
    id: 4,
    title: 'Office Complex Interior',
    category: 'Commercial',
    image: 'https://customer-assets.emergentagent.com/job_ad7e8f87-1d9a-44c7-94bb-e1bf1711e4b9/artifacts/owjpuo59_hf_20260124_183340_465bd098-5e09-4f21-88d0-0fa8aa6688de.png',
    description: 'Polished granite floors for corporate environments'
  },
  {
    id: 5,
    title: 'Retail Showroom',
    category: 'Retail',
    image: 'https://customer-assets.emergentagent.com/job_ad7e8f87-1d9a-44c7-94bb-e1bf1711e4b9/artifacts/50sbu06z_hf_20260124_182813_47718399-c11e-46ef-ba45-1f707e466152.png',
    description: 'Exhibition space showcasing premium granite collections'
  },
  {
    id: 6,
    title: 'Infrastructure Project',
    category: 'Infrastructure',
    image: 'https://images.unsplash.com/photo-1715927134295-6b1016e28414',
    description: 'Large-scale granite installation for public spaces'
  }
];

export const trustIndicators = [
  {
    title: 'Export-Ready Logistics',
    description: 'Container-load supply with FOB/CIF shipping terms'
  },
  {
    title: 'Consistent Grading',
    description: 'Rigorous quality control from quarry to export'
  },
  {
    title: 'Global Reach',
    description: 'Serving USA, Europe, Middle East, Southeast Asia'
  },
  {
    title: 'Samples Available',
    description: 'Free samples for qualified buyers'
  }
];

export const testimonials = [
  {
    id: 1,
    company: 'Leading Stone Importer',
    country: 'USA',
    text: 'Consistent quality and reliable delivery schedules. Rock Granites has become our trusted partner for Indian granite.'
  },
  {
    id: 2,
    company: 'Architectural Firm',
    country: 'UAE',
    text: 'The grading consistency across multiple container loads is exceptional. Perfect for our large-scale projects.'
  },
  {
    id: 3,
    company: 'Construction Group',
    country: 'UK',
    text: 'Professional export documentation and logistics support. Makes international procurement seamless.'
  }
];
